import { Component, Input, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Game } from 'src/app/interfaces/interfaces';
import { DataService } from 'src/app/services/data.service';
import { EventsService } from 'src/app/services/events.service';

@Component({
  selector: 'app-guess',
  templateUrl: './guess.component.html',
  styleUrls: ['./guess.component.scss']
})
export class GuessComponent implements OnInit {

  @Input() guess!: any;

  state$: Observable<Game>
  unit$: Observable<string>;

  constructor(private data: DataService, private events: EventsService) {
    this.state$ = this.data.getState();
    this.unit$ = this.data.getState().pipe(
      map(val => val.distUnit)
    );
  }
  

  ngOnInit(): void {

  }

  boxClicked() {
    this.events.boxClickedEvent('click');
  }
}
